import {priority} from '@priority-software/priority-proto-api/lib';
import {Operator} from '../../../_legacy/Searches/consts/operators';
import {
    DateApiOperatorMapping,
    RangeApiOperatorMapping,
    StrFilterOperatorMapping,
    TimeApiOperatorMapping
} from '../../../features/AppSearches/types/operator';

export const getOperatorFromStarPosition = (firstChar: string, lastChar: string) => {
    if (firstChar === '*' && lastChar === '*') return Operator.Contains;
    if (firstChar === '*' && lastChar !== '*') return Operator.EndsWith;
    if (lastChar === '*' && firstChar !== '*') return Operator.StartsWith;
    return false;
};

export const getOperatorFromCondition = (
    condition: priority.netitems.form.ICondition,
    columnType: priority.netitems.form.ColumnType
) => {
    const firstChar = condition.Values[0]?.[0];
    const lastChar = condition.Values[0]?.[condition.Values[0]?.length - 1];

    switch (columnType) {
        case priority.netitems.form.ColumnType.Date10:
        case priority.netitems.form.ColumnType.Date14:
        case priority.netitems.form.ColumnType.Date8: {
            return DateApiOperatorMapping[condition.Operator];
        }
        case priority.netitems.form.ColumnType.Time5:
        case priority.netitems.form.ColumnType.Time6: {
            return TimeApiOperatorMapping[condition.Operator];
        }

        case priority.netitems.form.ColumnType.Str:
        case priority.netitems.form.ColumnType.Rstr:
        case priority.netitems.form.ColumnType.Char: {
            switch (condition.Operator) {
                case priority.netitems.shared.ComparisonOperator.In:
                case priority.netitems.shared.ComparisonOperator.Eq: {
                    if (firstChar !== '*' && lastChar !== '*') return Operator.Equals;

                    return getOperatorFromStarPosition(firstChar, lastChar);
                }

                default:
                    return StrFilterOperatorMapping[condition.Operator];
            }
        }
        default:
            return RangeApiOperatorMapping[condition.Operator];
    }
};
